<a  href="{{data.link}}"  class="col-xs-12 for_whom-item ">
  <picture>
    <source media="(min-width:992px)" srcset="{{data.src}}" />
    <source media="(min-width:320px)" srcset="{{data.m_src}}" />
    <img [alt]="data.alt" width="310px" height="auto" [src]="data.m_src">
  </picture>
  <div class="item-link ">
    <span>{{data.label}}</span>
    <div class="read-more hover_action">
      <span>Читати далі</span>
      <app-i-arrow></app-i-arrow>
    </div>
  </div>
  <div class="line"></div>
</a>
